// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import Button, { ButtonIcon } from "@insite/mobius/Button/Button";
import Typography from "@insite/mobius/Typography";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import Menu, { MenuPresentationProps } from "@steiner/MobiusOverrides/Menu";
import { navigationDrawerStyles } from "@steiner/Overrides/Components/NavigationDrawer";
import { MappedLink } from "@steiner/Overrides/Widgets/Header/MainNavigation";
import MenuIcon from "@steiner/XDL/Icons/Menu";
import MenuClose from "@steiner/XDL/Icons/MenuClose";
import { FC, useState } from "react";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    links: MappedLink[];
    showQuickOrder?: boolean;
    showPayBillsLink?: boolean;
    showQuoteLink?: boolean;
    showReorderLink?: boolean;
}

type Props = OwnProps;

interface MenuCompactHeaderStyles {
    menu?: MenuPresentationProps;
}

export const menuCompactHeaderStyles: MenuCompactHeaderStyles = {};

const styles = menuCompactHeaderStyles;

const MenuCompactHeader: FC<Props> = ({ links }) => {
    const [isMenuOpen, setMenuOpen] = useState(false);

    return (
        <Menu
            onOpenChange={open => setMenuOpen(open)}
            menuItems={links}
            menuTrigger={
                <Button
                    className="menu-trigger-button"
                    {...navigationDrawerStyles.menuTriggerButton}
                    data-test-selector="expandMobileMenu"
                >
                    <ButtonIcon
                        className="menu-trigger-button-icon"
                        src={isMenuOpen ? MenuClose : MenuIcon}
                        size={18}
                        css={css`
                            ${isMenuOpen &&
                            css`
                                padding: 0 2px 1px;
                            `}
                        `}
                    />
                    <Typography>{translate("Menu")}</Typography>
                    <VisuallyHidden>{translate("menu")}</VisuallyHidden>
                </Button>
            }
            maxDepth={4}
            menuVariant="primary"
            offset={{
                mainAxis: 15,
            }}
            trigger="click"
            {...styles.menu}
        />
    );
};

export default MenuCompactHeader;
